import store from '../store';
import {DateTime} from "luxon";
import { TimeZonesInterface } from '@api/models/settings/TimeZonesInterface';

interface OffsetLocalStorageModel {
    timeZone: TimeZonesInterface;
    dateTime: string;
}

const liveTime = 60; // in minutes

const selectedKey = (): string => {
    return process.env.VUE_APP_SERVER + '_offset_' + store.state.session.backend;
}

const saveOffset = (timeZone: TimeZonesInterface): void => {
    const value: OffsetLocalStorageModel = {
        timeZone: timeZone,
        dateTime: DateTime.local().toISO()
    }
    localStorage.setItem(selectedKey(), JSON.stringify(value));
}

const getOffset = (): TimeZonesInterface | null => {
    let result = null;
    try {
        const value: OffsetLocalStorageModel = JSON.parse(localStorage.getItem(selectedKey()) || '{}');
        if (value && value?.timeZone?.defaultTimeZone?.offset) {
            const date = DateTime.fromISO(value.dateTime);
            if ((DateTime.local().diff(date, 'minutes').toObject()['minutes'] || 0) <= liveTime) {
                result = value.timeZone;
            }
        }
    }
    catch (e) {
        store.dispatch('reportException', e);
    }
    return result;
}

export  {saveOffset, getOffset}
